import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useCharging from "./useCharging";

import "./_Charging.scss";

const Charging = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useCharging();

  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  return (
    <div className="Charging">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Charging;
